import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/shadcn/card'
import { clsx } from 'clsx'

export function AccountCard({ children }: { children: React.ReactNode }) {
  return <Card className="flex-1 space-y-4 p-3 sm:p-5">{children}</Card>
}

export function AccountCardHeader({
  title,
  title2,
  description,
}: {
  title: string
  description: string
  title2?: string
}) {
  return (
    <CardHeader className="flex flex-col">
      {title2 ? (
        <CardTitle className="flex justify-between text-xl font-bold sm:text-2xl">
          <span>{title}</span>
          <span>{title2}</span>
        </CardTitle>
      ) : (
        <CardTitle className="text-xl font-bold sm:text-2xl">{title}</CardTitle>
      )}
      <CardDescription className="text-muted-foreground text-sm sm:text-base">
        {description}
      </CardDescription>
    </CardHeader>
  )
}

export function AccountCardContent({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return <CardContent className={clsx('space-y-4', className)}>{children}</CardContent>
}

export function AccountCardFooter({ children }: { children: React.ReactNode }) {
  return <CardFooter className="flex items-center justify-start space-x-4"> {children}</CardFooter>
}
